/*
 * Smooth anchor scrolling with a controllable duration.
 *
 * CSS `scroll-behavior: smooth` gives no control over how long the scroll
 * takes -- the browser picks it. This animates window.scrollTo() over a fixed
 * duration instead, so links like /#faq glide rather than snap.
 *
 * Targets are the <span class="section-anchor"> elements rendered by the
 * section-anchor snippet; their scroll-margin-top supplies the header offset.
 */
(function () {
  var DURATION = 900; // ms

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  // Honour the element's scroll-margin-top so the heading clears the header.
  function targetTop(el) {
    var style = window.getComputedStyle(el);
    var margin = parseFloat(style.scrollMarginTop) || 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset;
    return Math.max(0, top - margin);
  }

  function scrollToEl(el) {
    if (prefersReducedMotion()) {
      window.scrollTo(0, targetTop(el));
      return;
    }

    var start = window.pageYOffset;
    var end = targetTop(el);
    var distance = end - start;
    if (Math.abs(distance) < 2) return;

    var startTime = null;

    function step(now) {
      if (startTime === null) startTime = now;
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / DURATION, 1);
      window.scrollTo(0, start + distance * easeInOutCubic(progress));
      if (progress < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  function resolve(hash) {
    if (!hash || hash === '#') return null;
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (e) {
      id = hash.slice(1);
    }
    // getElementById avoids querySelector throwing on ids that are not
    // valid CSS identifiers (e.g. one starting with a digit).
    return document.getElementById(id);
  }

  // In-page clicks.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    if (link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey) return;

    // Only handle links pointing at THIS page.
    if (link.pathname !== window.location.pathname || link.host !== window.location.host) return;

    var el = resolve(link.hash);
    if (!el) return;

    event.preventDefault();
    scrollToEl(el);
    if (window.history && history.pushState) history.pushState(null, '', link.hash);
  });

  // Landing on the page with a hash already in the URL: the browser jumps
  // instantly, so re-run the eased scroll once layout has settled.
  window.addEventListener('load', function () {
    var el = resolve(window.location.hash);
    if (!el) return;
    window.setTimeout(function () {
      scrollToEl(el);
    }, 50);
  });
})();
